import { Box, Button, Flexbox, Label } from "codekit";
import { useEffect, useRef } from "react";
import useVersionCheck from "../../hooks/useVersionCheck";

const HIDDEN_RELOAD_MS = 30 * 60 * 1000;

/**
 * Banner de nueva version: avisa cuando hay un despliegue nuevo del front y
 * recarga automaticamente cuando es seguro hacerlo (la pestaña estuvo oculta
 * 30+ minutos, sin usuario interactuando con formularios)
 */
const Newverxx = () => {
  const isUpdateAvailable = useVersionCheck();
  const hiddenAtRef = useRef(null);

  useEffect(() => {
    const handleVisibility = () => {
      if (document.visibilityState === "hidden") {
        hiddenAtRef.current = Date.now();
        return;
      }
      const hiddenTime = hiddenAtRef.current ? Date.now() - hiddenAtRef.current : 0;
      if (isUpdateAvailable && hiddenTime >= HIDDEN_RELOAD_MS) {
        window.location.reload();
      }
    };
    document.addEventListener("visibilitychange", handleVisibility);
    return () => document.removeEventListener("visibilitychange", handleVisibility);
  }, [isUpdateAvailable]);

  if (!isUpdateAvailable) {
    return null;
  }

  return (
    <Box
      style={{ position: "fixed", bottom: "16px", right: "16px", zIndex: 9999 }}
      bg="warning-500"
      spacing={4}
      rounded="md"
      shadow
    >
      <Flexbox alignItems="center" gap={4}>
        <Label color="white">Hay una nueva versión de CIMA disponible</Label>
        <Button variant="secondary" size="m" type="button" onClick={() => window.location.reload()}>
          Actualizar
        </Button>
      </Flexbox>
    </Box>
  );
};

export default Newverxx;
